import { createSlice } from "@reduxjs/toolkit";

// prevent everytime login
const initialState = {
  data: [],
  selectedVisit: "",
  visitDate: "",
  visitRange: [{ startDate: "", endDate: "" }],
  dayCount: 0,
  selectedDate: "",
};

const visitsSlice = createSlice({
  name: "visitsReducer",
  initialState,
  reducers: {
    setVisitsData: (state, action) => {
      state.data = action.payload;
    },
    setSelectedVisit: (state, action) => {
      state.selectedVisit = action.payload;
    },
    setVisitDate: (state, action) => {
      state.visitDate = action.payload;
    },
    setVisitRange: (state, action) => {
      const { startDate, endDate } = action.payload;
      return {
        ...state,
        startDate,
        endDate,
      };
    },
    setDayCount: (state, action) => {
      state.dayCount = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    resetVisits: (state, action) => {
      return initialState;
    },
  },
});

export const {
  setVisitsData,
  setSelectedVisit,
  setVisitDate,
  resetVisits,
  setVisitRange,
  setDayCount,
  setSelectedDate,
} = visitsSlice.actions;
export default visitsSlice.reducer;
